<template lang="pug">
	article#plano(:data-index="`0${index}`" :class="{'indisponivel' : content.indisponivel }")
		.details
			h3 {{ content.title }}
			p {{ content.info }}
			router-link(v-if="content.indisponivel" :to="{ name:'pagina', params: { slug: 'contato' } }") Aguarde
			router-link(v-else :to="{ name:'pagina', params: { slug: 'contato' } }") Contrate agora
		Imagem(:content="content.image", v-if="content.image")
</template>

<script>
import {components} from '@/mixins/components'

export default {
	name: "component-plano",
	components,
	props: {
		content: {
			type: Object,
			required: true
		},
		index: {
			type: Number,
			default: 1
		},
	},
}
</script>

<style lang="stylus" scoped src="./Plano.styl"></style>
